import React, { lazy, Suspense } from 'react';

// Loaded only when a visitor opens an image, keeping it out of the main bundle
const Lightbox = lazy(() => import('react-image-lightbox'));

const getImageSrc = (image) => {
  if (!image) return undefined;
  if (typeof image === 'string') return image;
  return image.src || image.default || undefined;
};

const ImageLightBox = ({ images, open, setOpen, photoIndex, setPhotoIndex }) => {
  const getPortfolioImage = (index) => getImageSrc(images[index]?.main_img || images[index]?.img);

  return (
    <>
      {open && (
        <Suspense fallback={null}>
          <Lightbox
            mainSrc={getPortfolioImage(photoIndex)}
            nextSrc={getPortfolioImage((photoIndex + 1) % images.length)}
            prevSrc={getPortfolioImage((photoIndex + images.length - 1) % images.length)}
            onCloseRequest={() => setOpen(false)}
            onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
            onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
          />
        </Suspense>
      )}
    </>
  );
};

export default ImageLightBox;
